import LoginForm from '../../modules/auth/UI/Login';

function LoginPage() {
	return <LoginForm />;
}

export default LoginPage;
